import type { GuardAppEnvironment } from './types';

/**
 * Guard NOC — IP4CMS STAGING. Served from `dist/ip4cms-staging` behind Caddy at
 * `*.guard.ip4cms-staging.ip4x.systems`, on the ip4cms-staging stack (the same
 * core-api / tenant-api ip4cms uses). Multi-tenant by hostname: each
 * `{slug}.guard.ip4cms-staging.ip4x.systems` resolves its tenant via Core
 * `/resolve-domain` (so `defaultDomain` + `guardTenantId` are empty, and guards
 * sign in per tenant). Core must include `guard.ip4cms-staging.ip4x.systems` in
 * BASE_DOMAINS so `{slug}` is extracted and on-demand TLS is approved.
 */
export const env: GuardAppEnvironment = {
  production: true,
  buildMode: 'ip4cms-staging',
  apiBaseUrl: 'https://api.ip4cms-staging.ip4x.systems/v1',
  coreApiUrl: 'https://core-api.ip4cms-staging.ip4x.systems/v1',
  guardAuthMode: 'auto',
  guardTenantId: '',
  defaultDomain: '',
  portalBaseUrl: 'https://guard.ip4cms-staging.ip4x.systems',
  appName: 'Guard NOC',
  version: '1.0.0',
  panicPollIntervalMs: 8000,
  alarmSoundEnabled: true,
};
